import {
  AUTHOR_CHANGED,
  CATEGORY_CHANGED,
  CLEAR_FILTER,
  SEARCH_NAME,
} from "./actionTypes";

export const authorChanged = (authorName, authorChangeType) => {
  return {
    type: AUTHOR_CHANGED,
    payload: {
      authorName,
      authorChangeType,
    },
  };
};

export const categoryChanged = (categoryName, categoryChangeType) => {
  return {
    type: CATEGORY_CHANGED,
    payload: {
      categoryName,
      categoryChangeType,
    },
  };
};

export const searchData = (blogName) => {
  return {
    type: SEARCH_NAME,
    payload: blogName,
  };
};
export const clearFilter = () => {
  return {
    type: CLEAR_FILTER,
  };
};
